import React, { useState } from 'react';
import { FileText, TrendingUp, BarChart3, Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import logo from './assets/logo.png';

const Sidebar = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const menuItems = [
    // { id: 'dashboard', label: 'Dashboard', icon: Home, path: '/dashboard' },
    { id: 'loans', label: 'Loans', icon: FileText, path: '/loans' },
    { id: 'interest', label: 'Payment', icon: TrendingUp, path: '/interest' },
    { id: 'reports', label: 'Reports', icon: BarChart3, path: '/reports' },
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      {/* Mobile Menu Button */}
      <div className="lg:hidden fixed top-4 left-4 z-50">
        <button
          onClick={toggleMobileMenu}
          className="p-2 bg-indigo-900 text-white rounded-lg shadow-lg"
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={toggleMobileMenu}
        />
      )}

      {/* Sidebar */}
      <aside className={`fixed lg:static inset-y-0 left-0 z-40 w-64 bg-gradient-to-b from-indigo-900 via-indigo-800 to-purple-900 text-white min-h-screen transform transition-transform duration-300 ease-in-out ${
        isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
      }`}>
        <div className="p-4 md:p-6">
          {/* Logo Section */}
          <div className="flex justify-between items-center mb-4">
            <img src={logo} alt="Logo" className="w-40 md:w-52 h-14 md:h-18 rounded-xl shadow-md" />
            <button
              onClick={toggleMobileMenu}
              className="lg:hidden p-1 text-white hover:text-gray-300"
            >
              <X size={20} />
            </button>
          </div>
   
          {/* Navigation Menu */}
          <nav className="space-y-2">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.id}
                  to={item.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`w-full flex items-center space-x-3 px-3 md:px-4 py-2 md:py-3 rounded-lg transition-all duration-200 text-sm md:text-base ${
                    isActive
                      ? 'bg-white/20 shadow-lg'
                      : 'hover:bg-white/10'
                  }`}
                >
                  <Icon size={18} className="md:w-5 md:h-5" />
                  <span className="font-medium">{item.label}</span>
                </Link>
              );
            })}
          </nav>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
